import React from 'react';
import { getFromContext } from '../AlertFiltersContext';
import { 
  SelectedFilters,
  AlertJobCount,
  Filters,
} from './filter-sections';

export const AlertContent = () => {
  const { state } = getFromContext();
  const { editing, frequency } = state;
  
  return (
    <section className="tds-alert__content">
      <SelectedFilters />

      <>
        { frequency === 'disabled' &&
          <p className="tds-alert__content__pause"> Email notifications are paused for this alert </p>
        }
        { !editing && frequency !== 'disabled' && <p className="tds-alert__content__email"> Email notification: { frequency } </p> }
      </>

      <AlertJobCount />

      { editing && <Filters /> }
    </section>
  );
};
